export function trackPublicCountryEvent(eventName, payload = {}) {
  if (!eventName) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
}

